var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { API, Endpoints } from '@brg/api';
import { addOrChangeAdditionalInfo } from "../utilites/addOrChangeAdditionalInfo";
import useCommonProps from "../hooks/useCommonProps";
var post = axios.post;
export default function urlApi() {
    // const baseUrl = 'https://burgundyold.azurewebsites.net/';
    // const baseUrl = 'http://localhost:8085/';
    var baseUrl = process.env.REACT_APP_API_URL;
    var cardUrl = Endpoints.cardsMnePw;
    var baseQueryLink = 'https://test2.swarm1.space:80/';
    var baseCardLink = 'https://card.imagineworld.site/cardpage/';
    var imagineWorldLink = Endpoints.imagineWorld;
    var longReadGateLink = Endpoints.longread;
    var bookLink = Endpoints.geograffee;
    var youtubeapikey = 'AIzaSyCceRVp8rC2ssixcfLEeaoL9Eqa2ug-8gc';
    return {
        getUserFP: function (fp, device, browser, ip, data, userid, clientid) {
            return axios.get("https://api.burgdev.ru/account/api/Profile/GetUser?Fingerprint=".concat(fp, "&Device=").concat(device, "&Browser=").concat(browser, "&Ip=").concat(ip, "&Data=").concat(data));
        },
        getLongRead: function (idArea, idCountry, type) {
            return axios.get("".concat(longReadGateLink, "/api/Longread/GetLongread?idArea=").concat(idArea, "&idCountry=").concat(idCountry, "&typeLongread=").concat(type));
        },
        getbaseQueryLink: function () {
            return baseQueryLink;
        },
        getbaseCardLink: function () {
            return baseCardLink;
        },
        getImageQueryLink: function () {
            return "".concat(Endpoints.files, "/");
        },
        getProject: function (_a) {
            var id = _a.id;
            return __awaiter(this, void 0, void 0, function () {
                var url;
                var _this = this;
                return __generator(this, function (_b) {
                    url = "".concat(Endpoints.geograffee, "/api/Project/Get?idProject=").concat(id);
                    return [2 /*return*/, API.fetch(url, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        getIndustryImage: function (url) {
            return axios.get("https://files.burgdev.ru/".concat(url));
        },
        getCountryInfo: function (countryId) {
            return axios.get("https://api.imagineworld.site/api/Country/Info?id=".concat(countryId));
        },
        getCountryListByCoordinate: function (x, y, view) {
            return axios.get("https://api.imagineworld.site/api/Map/GetSquares?Longitude=".concat(x, "&Latitude=").concat(y, "&Type=").concat(view));
        },
        getCountryInnerPage: function (id) {
            return axios.get("https://api.imagineworld.site/api/Area/GetArea?id=".concat(id));
        },
        protectPost: function (_a) {
            var postId = _a.postId, action = _a.action;
            return post("".concat(longReadGateLink, "/api/post/protectSingle"), {
                postId: postId,
                action: action
            });
        },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic, rSort) {
            if (thematic)
                return API.request()
                    .endpoint(Endpoints.longread)
                    .url('api/post/GetMany')
                    .addQuery('idUser', idUser)
                    .addQuery('idLongread', idLongRead)
                    .addQuery('thematic', thematic)
                    .headers(sign ? { "Sign": sign } : {})
                    .get()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) { return ({ data: r }); });
            if (rSort) {
                return API.request()
                    .endpoint(Endpoints.longread)
                    .url('api/post/GetMany')
                    .addQuery('idUser', idUser)
                    .addQuery('idLongread', idLongRead)
                    .addQuery('sort', rSort)
                    .headers(sign ? { "Sign": sign } : {})
                    .get()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) { return ({ data: r }); });
            }
            return API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idUser', idUser)
                .addQuery('idLongread', idLongRead)
                .headers(sign ? { "Sign": sign } : {})
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) { return ({ data: r }); });
        },
        getLongReadPostsPaginated: function (idUser, idLongRead, sign, thematic, rSort, limit, offset, page) {
            var baseRequest = API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetManyPaginated')
                .addQuery('idUser', idUser)
                .addQuery('idLongread', idLongRead)
                .addQuery('limit', limit)
                .addQuery('offset', offset)
                .addQuery('page', page)
                .headers(sign ? { "Sign": sign } : {});
            thematic && baseRequest.addQuery('thematic', thematic);
            rSort && baseRequest.addQuery('sort', rSort);
            return baseRequest
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) { return ({ data: r.data }); });
        },
        insertCardIntoBook: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, bookId = _a.bookId;
            return post("".concat(bookLink, "/api/Book/UpdateCardInfo"), {
                bookId: bookId,
                cards: [
                    {
                        cardId: cardId,
                        operation: 0
                    }
                ]
            });
        },
        removeCardFromBook: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, bookId = _a.bookId;
            return post("".concat(bookLink, "/api/Book/UpdateCardInfo"), {
                bookId: bookId,
                cards: [
                    {
                        cardId: cardId,
                        operation: 1
                    }
                ]
            });
        },
        insertCard: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, position = _a.position;
            return post("".concat(longReadGateLink, "/api/post/AddByCard"), {
                cardId: cardId,
                longreadId: longreadId,
                postId: postId,
                position: position
            });
        },
        fetchChannelMessages: function (_a) {
            var entityId = _a.entityId, entityType = _a.entityType, page = _a.page, offset = _a.offset, limit = _a.limit, parentId = _a.parentId;
            return __awaiter(this, void 0, void 0, function () {
                var params, url;
                var _this = this;
                return __generator(this, function (_b) {
                    params = "entityId=".concat(entityId).concat(parentId ? "&parentId=".concat(parentId) : '', "&entityType=").concat(entityType, "&limit=").concat(limit, "&page=").concat(page, "&offset=").concat(offset);
                    url = "".concat(Endpoints.message, "/api/comment/GetByEntityPaging?").concat(params);
                    return [2 /*return*/, API.fetch(url, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        fetchPostsMessages: function (_a) {
            var rest = __rest(_a, []);
            return __awaiter(this, void 0, void 0, function () {
                var params, route, urls;
                var _this = this;
                return __generator(this, function (_b) {
                    params = rest;
                    route = "".concat(Endpoints.message, "/api/comment/GetByManyEntityPaging?");
                    urls = new URLSearchParams();
                    Object.keys(params).forEach(function (key) {
                        if (params[key] instanceof Array) {
                            for (var _i = 0, _a = params[key]; _i < _a.length; _i++) {
                                var val = _a[_i];
                                urls.append(key, val);
                            }
                        }
                        else {
                            urls.append(key, params[key]);
                        }
                    });
                    route = route + urls.toString();
                    return [2 /*return*/, API.fetch(route, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        fetchChatPermission: function (teamId) {
            return __awaiter(this, void 0, void 0, function () {
                var route;
                var _this = this;
                return __generator(this, function (_a) {
                    route = "".concat(Endpoints.geograffee, "/api/Team/Get?idTeam=").concat(teamId);
                    return [2 /*return*/, API.fetch(route, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        insertCardByImage: function (_a) {
            var postId = _a.postId, longreadId = _a.longreadId;
            return API.request()
                .endpoint(cardUrl)
                .url('/api/Card/AddByPost')
                .post()
                .body({
                postId: postId,
                longreadId: longreadId
            })
                .release();
        },
        /**
         * Returns the thematics data
         * @returns {AxiosPromise<any>}
         */
        getThematics: function () {
            return axios.get("https://api.imagineworld.site/api/Thematic/GetThematics?time=".concat(new Date().getTime()));
        },
        GetThematicContent: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetThematicContent"), {
                params: params
            });
        },
        GetReadMoreLongreads: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetReadMoreLongreads"), {
                params: params
            });
        },
        getDosier: function (idArea, idCountry) {
            if (!idCountry)
                return axios.get("https://api.imagineworld.site/api/Dosier/GetDosier?idArea=".concat(idArea));
            return axios.get("https://api.imagineworld.site/api/Dosier/GetDosier?idArea=".concat(idArea, "&idCountry=").concat(idCountry));
        },
        getYoutubeVideo: function (id) {
            // запрос не записывает ничего в стор, тк только для верстки
            return axios.get("https://www.googleapis.com/youtube/v3/videos?id=".concat(id, "&key=").concat(youtubeapikey, "&part=snippet"));
        },
        createPrefix: function (areaId, countryId, userId) {
            return post("".concat(imagineWorldLink, "/api/Prefix/Create"), {
                areaId: areaId,
                countryId: countryId
            }, {
                headers: {
                    userId: userId
                }
            });
        },
        addStepPrefix: function (clickedEl, userId) {
            return post("https://api.imagineworld.site/api/Prefix/AddStep", clickedEl, {
                headers: {
                    userId: userId
                }
            });
        },
        postFile: function (file) {
            var formData = new FormData();
            formData.append('file', file);
            return post("https://dev0.burgundy.ftbl.com/api/Vision", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        updateLongReadPosition: function (id, newposition) {
            return post("".concat(longReadGateLink, "/api/post/UpdatePosition"), {
                postId: id,
                newPosition: newposition
            });
        },
        incrementLongReadPosition: function (id, newposition) {
            return post("".concat(longReadGateLink, "/api/post/IncrementPosition"), {
                postId: id,
                newPosition: newposition
            });
        },
        getMuseums: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetMuseums"), { params: params });
        },
        getCountryLongreads: function (params) {
            return axios.get("".concat(longReadGateLink, "/api/Longread/GetLongreads"), {
                params: params
            });
        },
        getAreaLongreads: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Area/GetAreaLongreads"), {
                params: params
            });
        },
        deleteLongReadPost: function (id, onSubmit, onError) {
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Delete')
                .body({
                postId: id
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addNewHomeWorkPost: function (data, isMultiple, isSlider, onSubmit, onError) {
            var id = data.id, title = data.title, text = data.text, caption = data.caption, color = data.color, imageid = data.imageid, lgid = data.lgid, isFL = data.isFL, imgCaption = data.imgCaption, style = data.style, num = data.num, imageData = data.imageData, thematic = data.thematic, titlePosition = data.titlePosition, projectIds = data.projectIds, onAfterLoad = data.onAfterLoad, formId = data.formId, formPosition = data.formPosition, anchorText = data.anchorText, buttons = data.buttons, additionalInfo = data.additionalInfo, attachments = data.attachments, imageList = data.imageList, position = data.position;
            var posts;
            if (isSlider) {
                posts = {
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    attachments: imageList.map(function (data) { return ({
                        text: "".concat(data.text || ''),
                        textPosition: data === null || data === void 0 ? void 0 : data.textPosition,
                        description: data === null || data === void 0 ? void 0 : data.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(data.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }); }),
                    position: num,
                    style: style,
                    isFirstLetter: false,
                    title: '',
                    text: text,
                    titlePosition: titlePosition,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    projectIds: projectIds || [],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    anchorText: anchorText,
                    buttons: buttons,
                    caption: caption
                };
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Add')
                    .body(posts)
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            if (isMultiple) {
                posts = imageList.map(function (data, idx) { return ({
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: null,
                    longreadId: "".concat(lgid),
                    position: num || position + idx,
                    titlePosition: (data === null || data === void 0 ? void 0 : data.isCaptionSetted) ? 'caption-bottom' : 'bottom',
                    style: 'image',
                    isFirstLetter: false,
                    title: '',
                    text: "".concat(data === null || data === void 0 ? void 0 : data.text),
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: data === null || data === void 0 ? void 0 : data.caption,
                    attachments: [
                        {
                            text: 'string',
                            description: data === null || data === void 0 ? void 0 : data.caption,
                            isDeleted: true,
                            postAttachmentId: '',
                            referenceId: '',
                            type: 0,
                            file: {
                                fileId: "".concat(data.id),
                                containerId: 'string',
                                isNew: true,
                                type: 'string',
                                // url: data?.src,
                                url: 'string',
                                size: 'string',
                                localization: 'string'
                            }
                        }
                    ],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0
                }); });
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/AddMany')
                    .body(posts)
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Add')
                .body({
                additionalInfo: additionalInfo,
                attachments: attachments,
                internalId: {},
                postId: 'string',
                userId: id,
                longreadId: "".concat(lgid),
                position: num,
                style: style,
                isFirstLetter: false,
                title: '',
                text: text,
                titlePosition: titlePosition,
                color: color,
                isHidden: true,
                isDeleted: true,
                projectIds: projectIds || [],
                dateCreate: '2020-10-28T11:15:50.034Z',
                dateLastChange: '2020-10-28T11:15:50.034Z',
                like: 0,
                anchorText: anchorText,
                buttons: buttons,
                caption: caption
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addLongReadPost: function (_a, onSubmit, onError) {
            var id = _a.id, title = _a.title, text = _a.text, color = _a.color, imageid = _a.imageid, lgid = _a.lgid, isFL = _a.isFL, imgCaption = _a.imgCaption, style = _a.style, num = _a.num, imageData = _a.imageData, thematic = _a.thematic, titlePosition = _a.titlePosition, projectIds = _a.projectIds, onAfterLoad = _a.onAfterLoad, formId = _a.formId, formPosition = _a.formPosition, anchorText = _a.anchorText, buttons = _a.buttons, cardIds = _a.cardIds, additionalInfo = _a.additionalInfo, useRating = _a.useRating, ratings = _a.ratings, linkText = _a.linkText, caption = _a.caption;
            var isForm = style === 'forms';
            if (imageid === '') {
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Add')
                    .body({
                    additionalInfo: addOrChangeAdditionalInfo(additionalInfo || [], isForm ? [{ "name": "formId", "value": formId }, { "name": "formPosition", "value": formPosition }] : []),
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    style: style,
                    isFirstLetter: isFL,
                    useRating: useRating,
                    ratings: ratings,
                    title: title,
                    text: text,
                    caption: ['projects', 'two_pictures'].includes(style) ? imgCaption : caption,
                    titlePosition: titlePosition,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [],
                    projectIds: projectIds || [],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    anchorText: anchorText,
                    buttons: buttons,
                    cardIds: cardIds,
                    linkText: linkText
                })
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Add')
                .body({
                additionalInfo: additionalInfo || [],
                useRating: useRating,
                ratings: ratings,
                linkText: linkText,
                internalId: {},
                postId: 'string',
                userId: id,
                longreadId: "".concat(lgid),
                position: num,
                style: style,
                isFirstLetter: isFL,
                title: title,
                text: text,
                titlePosition: titlePosition,
                color: color,
                isHidden: true,
                isDeleted: true,
                caption: imgCaption,
                projectIds: projectIds || [],
                attachments: [
                    {
                        text: 'string',
                        description: imgCaption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(imageid),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }
                ],
                dateCreate: '2020-10-28T11:15:50.034Z',
                dateLastChange: '2020-10-28T11:15:50.034Z',
                like: 0,
                anchorText: anchorText,
                buttons: buttons
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addManyLongReadPost: function (imageList, id, lgid, isFL, title, text, color, num, thematic, callback, style, caption, titlePosition, anchorText, useRating, onSubmit, onError, isRibbon, additionalInfo) {
            var isMultipleImageUpload = ['super-puper-vote', 'slider', 'tile', 'two_pictures'].includes(style);
            var isSlider = style === 'slider';
            var isTile = style === 'tile';
            var isTwoPictures = style === 'two_pictures';
            var grouppedImg;
            var setPostStyle = function (data) { return ((data === null || data === void 0 ? void 0 : data.text) !== '' ? 'big' : 'image'); };
            if (isMultipleImageUpload) {
                grouppedImg = {
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    style: style,
                    anchorText: anchorText,
                    isFirstLetter: isFL,
                    title: title,
                    titlePosition: titlePosition,
                    isRibbon: isRibbon,
                    text: text,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: isSlider || isTwoPictures ? caption : '',
                    attachments: imageList.map(function (data) { return ({
                        text: "".concat(data.text || ''),
                        textPosition: data === null || data === void 0 ? void 0 : data.textPosition,
                        description: data === null || data === void 0 ? void 0 : data.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(data.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }); }),
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    useRating: useRating
                };
            }
            else {
                grouppedImg = imageList.map(function (data) { return ({
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    titlePosition: (data === null || data === void 0 ? void 0 : data.isCaptionSetted) ? 'caption-bottom' : 'bottom',
                    style: setPostStyle(data),
                    isFirstLetter: isFL,
                    title: title,
                    text: "".concat(data === null || data === void 0 ? void 0 : data.text),
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: data === null || data === void 0 ? void 0 : data.caption,
                    attachments: [
                        {
                            text: 'string',
                            description: data === null || data === void 0 ? void 0 : data.caption,
                            isDeleted: true,
                            postAttachmentId: '',
                            referenceId: '',
                            type: 0,
                            file: {
                                fileId: "".concat(data.id),
                                containerId: 'string',
                                isNew: true,
                                type: 'string',
                                // url: data?.src,
                                url: 'string',
                                size: 'string',
                                localization: 'string'
                            }
                        }
                    ],
                    useRating: useRating,
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0
                }); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url(isMultipleImageUpload ? 'api/post/Add' : 'api/post/AddMany')
                .body(grouppedImg)
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        updateLongReadPost: function (imageid, updatedpost, onSubmit, onError) {
            if (imageid === '') {
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Update')
                    .body(updatedpost)
                    .post()
                    .send()
                    .then(function (r) {
                    if (!r.ok) {
                        throw new Error("Request failed with status ".concat(r.status));
                    }
                    return r.text();
                })
                    .then(function (text) {
                    if (text) {
                        return JSON.parse(text);
                    }
                    return {};
                })
                    .then(function (data) { return onSubmit(data); })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Update')
                .body(updatedpost)
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        getUserCollectionCards: function (queryString) {
            return API.fetch("".concat(cardUrl, "/api/Card/GetList?").concat(queryString), {}).then(function (r) { return r.json(); });
        },
        getUserProducts: function (queryString) {
            return API.fetch("".concat(cardUrl, "/api/Products/GetList?").concat(queryString), {}).then(function (r) { return r.json(); });
        }
    };
}
/*
{
    "postId": "string",
    "userId": "string",
    "longreadId": "string",
    "title": "string",
    "text": "string",
    "color": "string",
    "attachments": [
      {
        "id": "string",
        "containerId": "string",
        "type": "string",
        "url": "string",
        "size": "string",
        "localization": "string"
      }
    ],
    "dateCreate": "2020-10-13T09:11:30.471Z",
    "dateLastChange": "2020-10-13T09:11:30.471Z",
    "like": 0
  }

  {
    userId: id,
    longreadId: 0,
    title: title,
    text: text
}
*/
//# sourceMappingURL=urlApi.js.mapvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { API, Endpoints } from '@brg/api';
import { addOrChangeAdditionalInfo } from "../utilites/addOrChangeAdditionalInfo";
import useCommonProps from "../hooks/useCommonProps";
var post = axios.post;
export default function urlApi() {
    // const baseUrl = 'https://burgundyold.azurewebsites.net/';
    // const baseUrl = 'http://localhost:8085/';
    var baseUrl = process.env.REACT_APP_API_URL;
    var cardUrl = Endpoints.cardsMnePw;
    var baseQueryLink = 'https://test2.swarm1.space:80/';
    var baseCardLink = 'https://card.imagineworld.site/cardpage/';
    var imagineWorldLink = Endpoints.imagineWorld;
    var longReadGateLink = Endpoints.longread;
    var bookLink = Endpoints.geograffee;
    var youtubeapikey = 'AIzaSyCceRVp8rC2ssixcfLEeaoL9Eqa2ug-8gc';
    return {
        getUserFP: function (fp, device, browser, ip, data, userid, clientid) {
            return axios.get("https://api.burgdev.ru/account/api/Profile/GetUser?Fingerprint=".concat(fp, "&Device=").concat(device, "&Browser=").concat(browser, "&Ip=").concat(ip, "&Data=").concat(data));
        },
        getLongRead: function (idArea, idCountry, type) {
            return axios.get("".concat(longReadGateLink, "/api/Longread/GetLongread?idArea=").concat(idArea, "&idCountry=").concat(idCountry, "&typeLongread=").concat(type));
        },
        getbaseQueryLink: function () {
            return baseQueryLink;
        },
        getbaseCardLink: function () {
            return baseCardLink;
        },
        getImageQueryLink: function () {
            return "".concat(Endpoints.files, "/");
        },
        getProject: function (_a) {
            var id = _a.id;
            return __awaiter(this, void 0, void 0, function () {
                var url;
                var _this = this;
                return __generator(this, function (_b) {
                    url = "".concat(Endpoints.geograffee, "/api/Project/Get?idProject=").concat(id);
                    return [2 /*return*/, API.fetch(url, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        getIndustryImage: function (url) {
            return axios.get("https://files.burgdev.ru/".concat(url));
        },
        getCountryInfo: function (countryId) {
            return axios.get("https://api.imagineworld.site/api/Country/Info?id=".concat(countryId));
        },
        getCountryListByCoordinate: function (x, y, view) {
            return axios.get("https://api.imagineworld.site/api/Map/GetSquares?Longitude=".concat(x, "&Latitude=").concat(y, "&Type=").concat(view));
        },
        getCountryInnerPage: function (id) {
            return axios.get("https://api.imagineworld.site/api/Area/GetArea?id=".concat(id));
        },
        protectPost: function (_a) {
            var postId = _a.postId, action = _a.action;
            return post("".concat(longReadGateLink, "/api/post/protectSingle"), {
                postId: postId,
                action: action
            });
        },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic, rSort) {
            if (thematic)
                return API.request()
                    .endpoint(Endpoints.longread)
                    .url('api/post/GetMany')
                    .addQuery('idUser', idUser)
                    .addQuery('idLongread', idLongRead)
                    .addQuery('thematic', thematic)
                    .headers(sign ? { "Sign": sign } : {})
                    .get()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) { return ({ data: r }); });
            if (rSort) {
                return API.request()
                    .endpoint(Endpoints.longread)
                    .url('api/post/GetMany')
                    .addQuery('idUser', idUser)
                    .addQuery('idLongread', idLongRead)
                    .addQuery('sort', rSort)
                    .headers(sign ? { "Sign": sign } : {})
                    .get()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) { return ({ data: r }); });
            }
            return API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idUser', idUser)
                .addQuery('idLongread', idLongRead)
                .headers(sign ? { "Sign": sign } : {})
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) { return ({ data: r }); });
        },
        getLongReadPostsPaginated: function (idUser, idLongRead, sign, thematic, rSort, limit, offset, page) {
            var baseRequest = API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetManyPaginated')
                .addQuery('idUser', idUser)
                .addQuery('idLongread', idLongRead)
                .addQuery('limit', limit)
                .addQuery('offset', offset)
                .addQuery('page', page)
                .headers(sign ? { "Sign": sign } : {});
            thematic && baseRequest.addQuery('thematic', thematic);
            rSort && baseRequest.addQuery('sort', rSort);
            return baseRequest
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) { return ({ data: r.data }); });
        },
        insertCardIntoBook: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, bookId = _a.bookId;
            return post("".concat(bookLink, "/api/Book/UpdateCardInfo"), {
                bookId: bookId,
                cards: [
                    {
                        cardId: cardId,
                        operation: 0
                    }
                ]
            });
        },
        removeCardFromBook: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, bookId = _a.bookId;
            return post("".concat(bookLink, "/api/Book/UpdateCardInfo"), {
                bookId: bookId,
                cards: [
                    {
                        cardId: cardId,
                        operation: 1
                    }
                ]
            });
        },
        insertCard: function (_a) {
            var cardId = _a.cardId, longreadId = _a.longreadId, postId = _a.postId, position = _a.position;
            return post("".concat(longReadGateLink, "/api/post/AddByCard"), {
                cardId: cardId,
                longreadId: longreadId,
                postId: postId,
                position: position
            });
        },
        fetchChannelMessages: function (_a) {
            var entityId = _a.entityId, entityType = _a.entityType, page = _a.page, offset = _a.offset, limit = _a.limit, parentId = _a.parentId;
            return __awaiter(this, void 0, void 0, function () {
                var params, url;
                var _this = this;
                return __generator(this, function (_b) {
                    params = "entityId=".concat(entityId).concat(parentId ? "&parentId=".concat(parentId) : '', "&entityType=").concat(entityType, "&limit=").concat(limit, "&page=").concat(page, "&offset=").concat(offset);
                    url = "".concat(Endpoints.message, "/api/comment/GetByEntityPaging?").concat(params);
                    return [2 /*return*/, API.fetch(url, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        fetchPostsMessages: function (_a) {
            var rest = __rest(_a, []);
            return __awaiter(this, void 0, void 0, function () {
                var params, route, urls;
                var _this = this;
                return __generator(this, function (_b) {
                    params = rest;
                    route = "".concat(Endpoints.message, "/api/comment/GetByManyEntityPaging?");
                    urls = new URLSearchParams();
                    Object.keys(params).forEach(function (key) {
                        if (params[key] instanceof Array) {
                            for (var _i = 0, _a = params[key]; _i < _a.length; _i++) {
                                var val = _a[_i];
                                urls.append(key, val);
                            }
                        }
                        else {
                            urls.append(key, params[key]);
                        }
                    });
                    route = route + urls.toString();
                    return [2 /*return*/, API.fetch(route, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        fetchChatPermission: function (teamId) {
            return __awaiter(this, void 0, void 0, function () {
                var route;
                var _this = this;
                return __generator(this, function (_a) {
                    route = "".concat(Endpoints.geograffee, "/api/Team/Get?idTeam=").concat(teamId);
                    return [2 /*return*/, API.fetch(route, {})
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, response];
                            });
                        }); })];
                });
            });
        },
        insertCardByImage: function (_a) {
            var postId = _a.postId, longreadId = _a.longreadId;
            return API.request()
                .endpoint(cardUrl)
                .url('/api/Card/AddByPost')
                .post()
                .body({
                postId: postId,
                longreadId: longreadId
            })
                .release();
        },
        /**
         * Returns the thematics data
         * @returns {AxiosPromise<any>}
         */
        getThematics: function () {
            return axios.get("https://api.imagineworld.site/api/Thematic/GetThematics?time=".concat(new Date().getTime()));
        },
        GetThematicContent: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetThematicContent"), {
                params: params
            });
        },
        GetReadMoreLongreads: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetReadMoreLongreads"), {
                params: params
            });
        },
        getDosier: function (idArea, idCountry) {
            if (!idCountry)
                return axios.get("https://api.imagineworld.site/api/Dosier/GetDosier?idArea=".concat(idArea));
            return axios.get("https://api.imagineworld.site/api/Dosier/GetDosier?idArea=".concat(idArea, "&idCountry=").concat(idCountry));
        },
        getYoutubeVideo: function (id) {
            // запрос не записывает ничего в стор, тк только для верстки
            return axios.get("https://www.googleapis.com/youtube/v3/videos?id=".concat(id, "&key=").concat(youtubeapikey, "&part=snippet"));
        },
        createPrefix: function (areaId, countryId, userId) {
            return post("".concat(imagineWorldLink, "/api/Prefix/Create"), {
                areaId: areaId,
                countryId: countryId
            }, {
                headers: {
                    userId: userId
                }
            });
        },
        addStepPrefix: function (clickedEl, userId) {
            return post("https://api.imagineworld.site/api/Prefix/AddStep", clickedEl, {
                headers: {
                    userId: userId
                }
            });
        },
        postFile: function (file) {
            var formData = new FormData();
            formData.append('file', file);
            return post("https://dev0.burgundy.ftbl.com/api/Vision", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        updateLongReadPosition: function (id, newposition) {
            return post("".concat(longReadGateLink, "/api/post/UpdatePosition"), {
                postId: id,
                newPosition: newposition
            });
        },
        incrementLongReadPosition: function (id, newposition) {
            return post("".concat(longReadGateLink, "/api/post/IncrementPosition"), {
                postId: id,
                newPosition: newposition
            });
        },
        getMuseums: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Museum/GetMuseums"), { params: params });
        },
        getCountryLongreads: function (params) {
            return axios.get("".concat(longReadGateLink, "/api/Longread/GetLongreads"), {
                params: params
            });
        },
        getAreaLongreads: function (params) {
            return axios.get("".concat(imagineWorldLink, "/api/Area/GetAreaLongreads"), {
                params: params
            });
        },
        deleteLongReadPost: function (id, onSubmit, onError) {
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Delete')
                .body({
                postId: id
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addNewHomeWorkPost: function (data, isMultiple, isSlider, onSubmit, onError) {
            var id = data.id, title = data.title, text = data.text, caption = data.caption, color = data.color, imageid = data.imageid, lgid = data.lgid, isFL = data.isFL, imgCaption = data.imgCaption, style = data.style, num = data.num, imageData = data.imageData, thematic = data.thematic, titlePosition = data.titlePosition, projectIds = data.projectIds, onAfterLoad = data.onAfterLoad, formId = data.formId, formPosition = data.formPosition, anchorText = data.anchorText, buttons = data.buttons, additionalInfo = data.additionalInfo, attachments = data.attachments, imageList = data.imageList, position = data.position;
            var posts;
            if (isSlider) {
                posts = {
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    attachments: imageList.map(function (data) { return ({
                        text: "".concat(data.text || ''),
                        textPosition: data === null || data === void 0 ? void 0 : data.textPosition,
                        description: data === null || data === void 0 ? void 0 : data.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(data.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }); }),
                    position: num,
                    style: style,
                    isFirstLetter: false,
                    title: '',
                    text: text,
                    titlePosition: titlePosition,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    projectIds: projectIds || [],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    anchorText: anchorText,
                    buttons: buttons,
                    caption: caption
                };
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Add')
                    .body(posts)
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            if (isMultiple) {
                posts = imageList.map(function (data, idx) { return ({
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: null,
                    longreadId: "".concat(lgid),
                    position: num || position + idx,
                    titlePosition: (data === null || data === void 0 ? void 0 : data.isCaptionSetted) ? 'caption-bottom' : 'bottom',
                    style: 'image',
                    isFirstLetter: false,
                    title: '',
                    text: "".concat(data === null || data === void 0 ? void 0 : data.text),
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: data === null || data === void 0 ? void 0 : data.caption,
                    attachments: [
                        {
                            text: 'string',
                            description: data === null || data === void 0 ? void 0 : data.caption,
                            isDeleted: true,
                            postAttachmentId: '',
                            referenceId: '',
                            type: 0,
                            file: {
                                fileId: "".concat(data.id),
                                containerId: 'string',
                                isNew: true,
                                type: 'string',
                                // url: data?.src,
                                url: 'string',
                                size: 'string',
                                localization: 'string'
                            }
                        }
                    ],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0
                }); });
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/AddMany')
                    .body(posts)
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Add')
                .body({
                additionalInfo: additionalInfo,
                attachments: attachments,
                internalId: {},
                postId: 'string',
                userId: id,
                longreadId: "".concat(lgid),
                position: num,
                style: style,
                isFirstLetter: false,
                title: '',
                text: text,
                titlePosition: titlePosition,
                color: color,
                isHidden: true,
                isDeleted: true,
                projectIds: projectIds || [],
                dateCreate: '2020-10-28T11:15:50.034Z',
                dateLastChange: '2020-10-28T11:15:50.034Z',
                like: 0,
                anchorText: anchorText,
                buttons: buttons,
                caption: caption
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addLongReadPost: function (_a, onSubmit, onError) {
            var id = _a.id, title = _a.title, text = _a.text, color = _a.color, imageid = _a.imageid, lgid = _a.lgid, isFL = _a.isFL, imgCaption = _a.imgCaption, style = _a.style, num = _a.num, imageData = _a.imageData, thematic = _a.thematic, titlePosition = _a.titlePosition, projectIds = _a.projectIds, onAfterLoad = _a.onAfterLoad, formId = _a.formId, formPosition = _a.formPosition, anchorText = _a.anchorText, buttons = _a.buttons, cardIds = _a.cardIds, additionalInfo = _a.additionalInfo, useRating = _a.useRating, ratings = _a.ratings, linkText = _a.linkText, caption = _a.caption;
            var isForm = style === 'forms';
            if (imageid === '') {
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Add')
                    .body({
                    additionalInfo: addOrChangeAdditionalInfo(additionalInfo || [], isForm ? [{ "name": "formId", "value": formId }, { "name": "formPosition", "value": formPosition }] : []),
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    style: style,
                    isFirstLetter: isFL,
                    useRating: useRating,
                    ratings: ratings,
                    title: title,
                    text: text,
                    caption: ['projects', 'two_pictures'].includes(style) ? imgCaption : caption,
                    titlePosition: titlePosition,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [],
                    projectIds: projectIds || [],
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    anchorText: anchorText,
                    buttons: buttons,
                    cardIds: cardIds,
                    linkText: linkText
                })
                    .post()
                    .send()
                    .then(function (r) { return r.json(); })
                    .then(function (r) {
                    onSubmit(r);
                })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Add')
                .body({
                additionalInfo: additionalInfo || [],
                useRating: useRating,
                ratings: ratings,
                linkText: linkText,
                internalId: {},
                postId: 'string',
                userId: id,
                longreadId: "".concat(lgid),
                position: num,
                style: style,
                isFirstLetter: isFL,
                title: title,
                text: text,
                titlePosition: titlePosition,
                color: color,
                isHidden: true,
                isDeleted: true,
                caption: imgCaption,
                projectIds: projectIds || [],
                attachments: [
                    {
                        text: 'string',
                        description: imgCaption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(imageid),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }
                ],
                dateCreate: '2020-10-28T11:15:50.034Z',
                dateLastChange: '2020-10-28T11:15:50.034Z',
                like: 0,
                anchorText: anchorText,
                buttons: buttons
            })
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        addManyLongReadPost: function (imageList, id, lgid, isFL, title, text, color, num, thematic, callback, style, caption, titlePosition, anchorText, useRating, onSubmit, onError, isRibbon, additionalInfo) {
            var isMultipleImageUpload = ['super-puper-vote', 'slider', 'tile', 'two_pictures'].includes(style);
            var isSlider = style === 'slider';
            var isTile = style === 'tile';
            var isTwoPictures = style === 'two_pictures';
            var grouppedImg;
            var setPostStyle = function (data) { return ((data === null || data === void 0 ? void 0 : data.text) !== '' ? 'big' : 'image'); };
            if (isMultipleImageUpload) {
                grouppedImg = {
                    additionalInfo: additionalInfo,
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    style: style,
                    anchorText: anchorText,
                    isFirstLetter: isFL,
                    title: title,
                    titlePosition: titlePosition,
                    isRibbon: isRibbon,
                    text: text,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: isSlider || isTwoPictures ? caption : '',
                    attachments: imageList.map(function (data) { return ({
                        text: "".concat(data.text || ''),
                        textPosition: data === null || data === void 0 ? void 0 : data.textPosition,
                        description: data === null || data === void 0 ? void 0 : data.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(data.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    }); }),
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0,
                    useRating: useRating
                };
            }
            else {
                grouppedImg = imageList.map(function (data) { return ({
                    internalId: {},
                    postId: 'string',
                    userId: id,
                    longreadId: "".concat(lgid),
                    position: num,
                    titlePosition: (data === null || data === void 0 ? void 0 : data.isCaptionSetted) ? 'caption-bottom' : 'bottom',
                    style: setPostStyle(data),
                    isFirstLetter: isFL,
                    title: title,
                    text: "".concat(data === null || data === void 0 ? void 0 : data.text),
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    caption: data === null || data === void 0 ? void 0 : data.caption,
                    attachments: [
                        {
                            text: 'string',
                            description: data === null || data === void 0 ? void 0 : data.caption,
                            isDeleted: true,
                            postAttachmentId: '',
                            referenceId: '',
                            type: 0,
                            file: {
                                fileId: "".concat(data.id),
                                containerId: 'string',
                                isNew: true,
                                type: 'string',
                                // url: data?.src,
                                url: 'string',
                                size: 'string',
                                localization: 'string'
                            }
                        }
                    ],
                    useRating: useRating,
                    dateCreate: '2020-10-28T11:15:50.034Z',
                    dateLastChange: '2020-10-28T11:15:50.034Z',
                    like: 0
                }); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url(isMultipleImageUpload ? 'api/post/Add' : 'api/post/AddMany')
                .body(grouppedImg)
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        updateLongReadPost: function (imageid, updatedpost, onSubmit, onError) {
            if (imageid === '') {
                return API.request()
                    .endpoint(longReadGateLink)
                    .url('api/post/Update')
                    .body(updatedpost)
                    .post()
                    .send()
                    .then(function (r) {
                    if (!r.ok) {
                        throw new Error("Request failed with status ".concat(r.status));
                    }
                    return r.text();
                })
                    .then(function (text) {
                    if (text) {
                        return JSON.parse(text);
                    }
                    return {};
                })
                    .then(function (data) { return onSubmit(data); })
                    .catch(function (e) { return onError(e); });
            }
            return API.request()
                .endpoint(longReadGateLink)
                .url('api/post/Update')
                .body(updatedpost)
                .post()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                onSubmit(r);
            })
                .catch(function (e) { return onError(e); });
        },
        getUserCollectionCards: function (queryString) {
            return API.fetch("".concat(cardUrl, "/api/Card/GetList?").concat(queryString), {}).then(function (r) { return r.json(); });
        },
        getUserProducts: function (queryString) {
            return API.fetch("".concat(cardUrl, "/api/Products/GetList?").concat(queryString), {}).then(function (r) { return r.json(); });
        }
    };
}
/*
{
    "postId": "string",
    "userId": "string",
    "longreadId": "string",
    "title": "string",
    "text": "string",
    "color": "string",
    "attachments": [
      {
        "id": "string",
        "containerId": "string",
        "type": "string",
        "url": "string",
        "size": "string",
        "localization": "string"
      }
    ],
    "dateCreate": "2020-10-13T09:11:30.471Z",
    "dateLastChange": "2020-10-13T09:11:30.471Z",
    "like": 0
  }

  {
    userId: id,
    longreadId: 0,
    title: title,
    text: text
}
*/
//# sourceMappingURL=urlApi.js.map